//@flow
import type { SignUpLoginActionType } from './actions';
import type { StateType } from '../../reducers';
import { customerSelector } from '../../Customer/selectors';

export const initialState: LoginStateType = {
  email: '',
  password: '',
  optionExternalCommercial: false,
  optionInternalCommercial: false,
};

export default (state: LoginStateType = initialState, action: SignUpLoginActionType) => {
  switch (action.type) {
    case 'SIGNUP_SET_LOGIN':
      return {
        ...state,
        ...action.payload,
      };

    case 'SIGNUP_SET_VALIDATION_CODE':
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export type LoginStateType = {|
  email: string,
  password: string,
  optionExternalCommercial: boolean,
  optionInternalCommercial: boolean,
  validationCode?: string,
|};

const loginStateSelector = (state: StateType): LoginStateType => state.signUp.login;

export const loginSelector = (
  state: StateType
): {
  email: string,
  password: string,
  validationCode: ?string,
  optionExternalCommercial?: boolean,
  optionInternalCommercial?: boolean,
} => {
  const loginState = loginStateSelector(state);
  let { email } = loginState;
  if (email === '') {
    const customer = customerSelector(state);
    if (customer) email = customer.login.email;
  }

  const { password, validationCode, optionExternalCommercial, optionInternalCommercial } = loginState;

  return { email, password, validationCode, optionExternalCommercial, optionInternalCommercial };
};

export const emailSelector = (state: StateType): string => loginStateSelector(state).email;

export const hasLoginInfoSelector = (state: StateType): boolean => !!emailSelector(state);

export const createAccountFormValuesSelector = (
  state: StateType
): {| email: string, password: string, optionExternalCommercial: boolean, optionInternalCommercial: boolean |} => {
  const login = loginStateSelector(state);
  return {
    email: login.email,
    password: login.password,
    optionExternalCommercial: login.optionExternalCommercial,
    optionInternalCommercial: login.optionInternalCommercial,
  };
};
